// extracted by mini-css-extract-plugin
module.exports = {"page":"PickBookPage_page__2PLRn","close_button":"PickBookPage_close_button__2pSeT","title":"PickBookPage_title__2AqAw","divider":"PickBookPage_divider__3IZ2w"};